/**
 * Defines if online order is possible and pages or links will be shown.
 *
 * @return boolean
 */
export function isOnlineOrderAvailable(): boolean {
  const countryWithOnlineOrder: string[] = ['de', 'at', 'ch', 'nl']

  return countryWithOnlineOrder.includes(
    process.env.NUXT_ENV_DEFAULT_CODE || ('de' as string)
  )
}
